import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer, createTransform } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";

import misSurveyReducer from "./features/misSurveySlice";
import { decryptData, encryptData } from "utils/encryptionUtil";

// const encryptTransform = createTransform(
// 	// Encrypt state on its way to being stored
// 	(inboundState, key) => {
// 		try {
// 			const stringifiedState = JSON.stringify(inboundState);
// 			const encrypted = CryptoJS.AES.encrypt(
// 				stringifiedState,
// 				SECRET_KEY
// 			).toString();
// 			return encrypted;
// 		} catch (err) {
// 			console.error("Encryption error:", err);
// 			return inboundState;
// 		}
// 	},
// 	// Decrypt state on its way back
// 	(outboundState, key) => {
// 		try {
// 			if (typeof outboundState !== "string") return outboundState;

// 			const bytes = CryptoJS.AES.decrypt(outboundState, SECRET_KEY);
// 			const decrypted = bytes.toString(CryptoJS.enc.Utf8);
// 			return JSON.parse(decrypted);
// 		} catch (err) {
// 			console.error("Decryption error:", err);
// 			return outboundState;
// 		}
// 	}
// );

export const encryptTransform = createTransform(
	(inboundState) => encryptData(inboundState) ?? inboundState,
	(outboundState) => decryptData(outboundState) ?? outboundState
);

const persistConfig = {
	key: "smis::heartbeat",
	storage: storageSession,
	transforms: [encryptTransform],
};

const rootReducer = combineReducers({
	misSurvey: misSurveyReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
	reducer: persistedReducer,
	devTools: process.env.NODE_ENV !== "production",
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
			},
		}),
});

export const persistor = persistStore(store);
